import { render } from "./ResumenInfo.vue?vue&type=template&id=1fe7acd7&scoped=true"
import script from "./ResumenInfo.vue?vue&type=script&lang=js"
export * from "./ResumenInfo.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./ResumenInfo.vue?vue&type=style&index=1&id=1fe7acd7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe7acd7"]])

export default __exports__